/**
 * This component was introduced because we do not want to use CodeEditor as input
 * because it is not quite suitable and not performant for this use case.
 *
 * At the same time we can not use Input component because it
 * has no ability to extend it in a way we need for this case.
 */
import { twJoin, twMerge } from "tailwind-merge";

export const SimpleOperatorInput: React.FC<{
  value: string;
  onChange: (value: string, event: React.ChangeEvent<HTMLInputElement>) => void;
  prefix?: React.ReactNode;
}> = ({ value, onChange, prefix }) => {
  return (
    <div
      className={twMerge(
        "flex h-8 w-50 items-center overflow-hidden rounded-lg border pl-1.5 font-inter-normal-12px",
        "gap-x-1 border-gray-200 focus-within:border-indigo-600 focus-within:ring-2 focus-within:ring-indigo-600/25",
      )}
    >
      {prefix}
      <input
        className={twJoin(
          "w-full min-w-0 flex-1 py-[5px] pr-2 outline-none placeholder:text-gray-500",
          "font-inter-normal-12px placeholder:font-inter-normal-12px",
        )}
        role="input"
        tabIndex={-1}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value, e)}
      />
    </div>
  );
};
